export const INFORMATION_BAR_EVENTS = {
  SELECT_INFOBAR_OFFER: "web_select_infobar_offer",
};
